import http from './http';

const ENDPOINTS = {
  // Bed management endpoints
  BEDS: '/api/v1/beds',
  BED_BY_ID: (id) => `/api/v1/beds/${id}`,
  WARD_BEDS: (wardId) => `/api/v1/beds/ward/${wardId}`,
  AVAILABLE_BEDS: '/api/v1/beds/available',
  BED_STATISTICS: '/api/v1/beds/statistics',
  ALLOCATE_BED: (id) => `/api/v1/beds/${id}/allocate`,
  DEALLOCATE_BED: (id) => `/api/v1/beds/${id}/deallocate`,
  TRANSFER_PATIENT: (id) => `/api/v1/beds/${id}/transfer`,
};

/**
 * Bed Management API Service
 */
export const bedAPI = {
  /**
   * Get all beds with filtering and pagination
   */
  getBeds: async (params = {}) => {
    const response = await http.get(ENDPOINTS.BEDS, { params });
    return response.data;
  },

  /**
   * Create a new bed
   */
  createBed: async (bedData) => {
    const response = await http.post(ENDPOINTS.BEDS, bedData);
    return response.data;
  },

  /**
   * Get bed by ID
   */
  getBedById: async (id) => {
    const response = await http.get(ENDPOINTS.BED_BY_ID(id));
    return response.data;
  },

  /**
   * Update bed information
   */
  updateBed: async (id, updateData) => {
    const response = await http.put(ENDPOINTS.BED_BY_ID(id), updateData);
    return response.data;
  },

  /**
   * Delete a bed
   */
  deleteBed: async (id) => {
    const response = await http.delete(ENDPOINTS.BED_BY_ID(id));
    return response.data;
  },

  /**
   * Get beds in a specific ward
   */
  getWardBeds: async (wardId, params = {}) => {
    const response = await http.get(ENDPOINTS.WARD_BEDS(wardId), { params });
    return response.data;
  },

  /**
   * Get available beds
   */
  getAvailableBeds: async (params = {}) => {
    const response = await http.get(ENDPOINTS.AVAILABLE_BEDS, { params });
    return response.data;
  },

  /**
   * Get bed statistics
   */
  getStatistics: async () => {
    const response = await http.get(ENDPOINTS.BED_STATISTICS);
    return response.data;
  },

  /**
   * Allocate bed to a patient
   */
  allocateBed: async (id, allocationData) => {
    const response = await http.post(ENDPOINTS.ALLOCATE_BED(id), allocationData);
    return response.data;
  },

  /**
   * Deallocate bed from patient
   */
  deallocateBed: async (id, deallocationData = {}) => {
    const response = await http.post(ENDPOINTS.DEALLOCATE_BED(id), deallocationData);
    return response.data;
  },

  /**
   * Transfer patient between beds
   */
  transferPatient: async (id, transferData) => {
    const response = await http.post(ENDPOINTS.TRANSFER_PATIENT(id), transferData);
    return response.data;
  }
};

export default bedAPI;